import { FormMeta } from '../../types/interface';

const PROXY_TYPE_OPTIONS = [
  { value: 'Manual', label: 'common.manual' },
  { value: 'Auto', label: 'common.auto' }
];
export const PROXY_FORM_FIELDS: FormMeta[] = [
  {
    id: 'proxy_type',
    name: 'proxyType',
    label: 'mdm.proxy.type',
    type: 'select',
    required: true,
    defaultValue: 'Manual',
    options: PROXY_TYPE_OPTIONS
  },
  {
    id: 'server_host',
    name: 'host',
    label: 'mdm.proxy.host',
    type: 'text',
    required: false,
    placeholder: 'mdm.proxy.host.placeholder',
    defaultValue: '',
    condition: {
      dependsOn: 'proxyType',
      operator: 'equal' as const,
      value: 'Manual'
    },
    validation: {
      required: false,
      conditionalRule: {
        dependsOn: 'proxyType',
        operator: 'equal' as const,
        value: 'Manual',
        required: true
      }
    }
  },
  {
    id: 'server_port',
    name: 'port',
    label: 'mdm.proxy.port',
    type: 'number',
    required: false,
    placeholder: 'mdm.common.port.placeholder',
    defaultValue: null,
    condition: {
      dependsOn: 'proxyType',
      operator: 'equal' as const,
      value: 'Manual'
    },
    validation: {
      required: false,
      conditionalRule: {
        dependsOn: 'proxyType',
        operator: 'equal' as const,
        value: 'Manual',
        required: true
      },
      min: 1,
      max: 65535
    }
  },
  {
    id: 'username',
    name: 'userName',
    label: 'mdm.proxy.username',
    type: 'text',
    required: false,
    placeholder: 'mdm.common.username.placeholder',
    defaultValue: '',
    condition: {
      dependsOn: 'proxyType',
      operator: 'equal' as const,
      value: 'Manual'
    },
    validation: {
      required: false
    }
  },
  {
    id: 'password',
    name: 'password',
    label: 'mdm.proxy.password',
    type: 'password',
    required: false,
    placeholder: 'mdm.common.password.placeholder',
    defaultValue: '',
    condition: {
      dependsOn: 'proxyType',
      operator: 'equal' as const,
      value: 'Manual'
    },
    validation: {
      required: false
    }
  },
  {
    id: 'pac_url',
    name: 'pacURL',
    label: 'mdm.proxy.pac.url',
    type: 'text',
    required: false,
    placeholder: 'mdm.pac.url.placeholder',
    defaultValue: '',
    condition: {
      dependsOn: 'proxyType',
      operator: 'equal' as const,
      value: 'Auto'
    },
    validation: {
      required: false,
      conditionalRule: {
        dependsOn: 'proxyType',
        operator: 'equal' as const,
        value: 'Auto',
        required: true
      },
      pattern: '^https?://[\\w\\.-]+(?:\\:[0-9]+)?(?:/[\\w\\.-]*)*/?$'
    }
  },
  {
    id: 'pac_fallback_allowed',
    name: 'pacFallbackAllowed',
    label: 'mdm.proxy.pac.fallback',
    type: 'checkbox',
    required: false,
    defaultValue: false,
    condition: {
      dependsOn: 'proxyType',
      operator: 'equal' as const,
      value: 'Auto'
    }
  },
  {
    id: 'proxy_captive_login_allowed',
    name: 'proxyCaptiveLoginAllowed',
    label: 'mdm.proxy.captive.login',
    type: 'checkbox',
    required: false,
    defaultValue: false
  }
];
